/* ============================================================
   Earth Energy — Buy Box v2 controller
   Size cards + delivery options (Subscribe & Save / Buy Once) +
   Shop Pay dynamic checkout. Flavor-aware (colostrum).
   ALL prices come from data-* rendered LIVE by Liquid
   (Shopify variant price + Recharge first/recurring). Nothing hardcoded.
   Keeps hidden form inputs (id / selling_plan) synced so the native
   {{ form | payment_button }} Shop Pay button checks out the selection.
   ============================================================ */
(function(){
  function money(v){ return parseFloat(String(v).replace(/[^0-9.\-]/g,'')) || 0; }
  function fmt(sample, value){
    var m = String(sample||'$0').match(/^([^\d\-]*)([\d.,]+)(.*)$/);
    var pre = m ? m[1] : '$', suf = m ? m[3] : '';
    return pre + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suf;
  }

  /* ---------- open cart drawer (theme-agnostic) ---------- */
  function tryDrawer(root){
    var sels=[]; var custom=root&&root.getAttribute('data-cart-selector'); if(custom) sels.push(custom);
    try{ var cd=document.querySelector('cart-drawer'); if(cd&&typeof cd.open==='function'){ cd.open(); return true; } }catch(e){}
    sels=sels.concat(['[data-cart-drawer-toggle]','[data-drawer="cart"]','button[aria-controls="CartDrawer"]','a[aria-controls="CartDrawer"]','.js-drawer-open-cart','.js-cart-trigger','.cart-drawer-toggle','[data-cart-toggle]','[data-action="open-cart"]','#cart-icon-bubble']);
    for(var i=0;i<sels.length;i++){ try{ var el=document.querySelector(sels[i]); if(el){ el.click(); return true; } }catch(e){} }
    return false;
  }
  function openCart(root){
    var action=(root&&root.getAttribute('data-cart-action'))||'drawer';
    if(action==='cart'||action==='page'){ window.location.href='/cart'; return; }
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      ['cart:refresh','cart:updated','cart-updated','ajaxCart:afterCartLoad','cart:build','theme:cart:reload','cart:open','cart:added','ajaxProduct:added'].forEach(function(n){ try{ document.dispatchEvent(new CustomEvent(n,{bubbles:true,detail:{cart:cart}})); }catch(e){} });
      try{ document.documentElement.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart:cart}})); }catch(e){}
      if(!tryDrawer(root)){ window.location.href='/cart'; }
    }).catch(function(){ window.location.href='/cart'; });
  }

  function initBuy2(box){
    if(box.dataset.b2Init==='1') return; box.dataset.b2Init='1';
    var root = box.closest('.ee-pdp') || document;
    var subPctFallback = parseFloat(box.getAttribute('data-sub-pct'))||15;

    var cards      = [].slice.call(box.querySelectorAll('.b2-size'));
    var flavorBtns = [].slice.call(box.querySelectorAll('.b2-flavor button'));
    var delEl      = box.querySelector('.b2-delivery');
    var atcMain    = box.querySelector('.b2-atc');
    var footEl     = box.querySelector('.b2-footline');
    var idInput    = box.querySelector('.js-variant-input');
    var planInput  = box.querySelector('.js-plan-input'); /* may be absent; created on demand */

    /* external hooks (sticky + final CTA) */
    var sticky     = document.querySelector('.ee-pdp-sticky');
    var stickyPrice= sticky ? sticky.querySelector('.st-price') : null;
    var stickyBtns = [].slice.call(document.querySelectorAll('.ee-pdp-sticky .js-atc'));
    var finalPrice = root.querySelector ? root.querySelector('.js-final-price') : null;
    var finalSub   = root.querySelector ? root.querySelector('.js-final-sub') : null;

    var state = { size: null, delivery: 'onetime', flavor: 'unflav' };
    /* default size = the one with .sel, else the middle card, else first */
    var pre = box.querySelector('.b2-size.sel');
    state.size = pre ? pre.getAttribute('data-size') : (cards[1]||cards[0]||{}).getAttribute ? (cards[1]||cards[0]).getAttribute('data-size') : null;

    function card(){ for(var i=0;i<cards.length;i++){ if(cards[i].getAttribute('data-size')===state.size) return cards[i]; } return cards[0]; }
    function pick(c, base){
      var d=c.dataset;
      if(state.flavor==='choc' && d[base+'Choc']!=null && d[base+'Choc']!=='') return d[base+'Choc'];
      return d[base]||'';
    }
    function data(c){
      var one=pick(c,'onetime'), sub=pick(c,'sub'), rec=pick(c,'subRecur')||sub, comp=pick(c,'compare')||one;
      var variant = flavorBtns.length ? (state.flavor==='choc'?c.dataset.variantChoc:c.dataset.variantUnflav) : c.dataset.variant;
      return {
        one:money(one), sub:money(sub), rec:money(rec), comp:money(comp),
        oneS:one, subS:sub||one,
        variant:variant||'', plan:c.dataset.plan||'',
        count:c.dataset.count||'', days:c.dataset.days||'', word:c.dataset.word||'servings',
        desc:c.dataset.desc||'', title:c.dataset.title||'', perLabel:c.dataset.perLabel||''
      };
    }

    /* ---- render a size card's price block (from live data, flavor-aware) ---- */
    function renderCard(c){
      var d=data(c);
      var was=c.querySelector('.b2-was'), now=c.querySelector('.b2-now'), per=c.querySelector('.b2-per'), save=c.querySelector('.b2-save');
      if(now) now.textContent = fmt(d.oneS, d.one);
      if(was){ was.style.display='none'; }
      if(per){ var n=parseInt(c.dataset.packs||c.getAttribute('data-size'),10)||1; per.textContent = fmt(d.oneS, d.one/n) + (d.perLabel||''); }
      if(save){ var pct=d.comp>0?Math.round((d.comp-d.one)/d.comp*100):0; if(pct>0){ save.textContent='SAVE '+pct+'%'; save.style.display=''; } else save.style.display='none'; }
    }

    /* ---- render delivery rows for the selected size + flavor ---- */
    function renderDelivery(){
      var d=data(card());
      var base = d.comp>d.one ? d.comp : d.one;
      var saveToday = base - d.sub;
      var lifePct = d.one>0 ? Math.round((d.one-d.rec)/d.one*100) : subPctFallback;
      if(lifePct<=0) lifePct=subPctFallback;
      var bolt='<svg class="bolt" viewBox="0 0 24 24"><path d="M13 2 4 14h6l-1 8 10-13h-7l1-7z"/></svg>';
      var banner = saveToday>0.01
        ? '<div class="b2-banner">'+bolt+' SAVE '+fmt(d.subS,saveToday)+' TODAY + '+lifePct+'% OFF EVERY ORDER FOR LIFE</div>'
        : '<div class="b2-banner">'+bolt+' '+lifePct+'% OFF EVERY ORDER FOR LIFE</div>';
      var recNote = (d.rec>0 && Math.abs(d.rec-d.sub)>0.01) ? '<span class="b2-recur">then '+fmt(d.subS,d.rec)+'/delivery</span>' : '';
      var subWas = '';
      var onceWas = '';
      delEl.innerHTML =
        '<div class="b2-opt'+(state.delivery==='subscribe'?' sel':'')+'" data-del="subscribe">'+
          banner+
          '<div class="b2-row"><div class="b2-left"><span class="b2-radio"></span>'+
            '<div><div class="b2-name">Subscribe &amp; Save</div>'+(recNote?'<div style="font-size:12px;color:#6a7a7e">'+recNote+'</div>':'')+'</div></div>'+
            '<div class="b2-price">'+subWas+'<span class="b2-now">'+fmt(d.subS,d.sub)+'</span></div></div>'+
        '</div>'+
        '<div class="b2-opt'+(state.delivery==='onetime'?' sel':'')+'" data-del="onetime">'+
          '<div class="b2-row"><div class="b2-left"><span class="b2-radio"></span><div class="b2-name">Buy Once</div></div>'+
          '<div class="b2-price">'+onceWas+'<span class="b2-now">'+fmt(d.oneS,d.one)+'</span></div></div>'+
        '</div>';
    }

    function syncForm(d, isSub){
      if(idInput) idInput.value = d.variant || '';
      if(isSub && d.plan){
        if(!planInput){ planInput=document.createElement('input'); planInput.type='hidden'; planInput.name='selling_plan'; planInput.className='js-plan-input'; (idInput?idInput.parentNode:box).insertBefore(planInput, idInput?idInput.nextSibling:null); }
        planInput.disabled=false; planInput.value=d.plan;
      } else if(planInput){ planInput.value=''; planInput.disabled=true; }
    }

    function render(){
      cards.forEach(function(c){ c.classList.toggle('sel', c.getAttribute('data-size')===state.size); renderCard(c); });
      renderDelivery();
      var d=data(card());
      var isSub = state.delivery==='subscribe';
      var priceVal = isSub ? d.sub : d.one, priceS = isSub ? d.subS : d.oneS;
      var priceLabel = fmt(priceS, priceVal) + (isSub?'/delivery':'');
      if(atcMain){ var ap=atcMain.querySelector('.atc-price'); if(ap) ap.textContent=priceLabel; }
      if(footEl && d.count){ footEl.textContent = d.count+' '+d.word+' · '+d.days+'-day supply · '+d.desc; }
      if(stickyPrice) stickyPrice.textContent = d.title+' · '+fmt(priceS,priceVal);
      if(finalPrice) finalPrice.textContent = fmt(priceS,priceVal);
      if(finalSub) finalSub.textContent = d.title+' · '+d.days+'-day supply'+(isSub?' · Subscribe & Save':'');
      syncForm(d, isSub);
    }

    /* ---- events ---- */
    box.querySelector('.b2-sizes').addEventListener('click', function(e){ var c=e.target.closest('.b2-size'); if(c){ state.size=c.getAttribute('data-size'); render(); } });
    delEl.addEventListener('click', function(e){ var o=e.target.closest('.b2-opt'); if(o){ state.delivery=o.getAttribute('data-del'); render(); } });
    flavorBtns.forEach(function(b){ b.addEventListener('click', function(){ flavorBtns.forEach(function(x){x.classList.remove('active');}); b.classList.add('active'); state.flavor=b.getAttribute('data-flavor'); render(); }); });

    /* ---- add to cart (AJAX) with drawer-open + re-add reset ---- */
    function addToCart(btn){
      var d=data(card()); var isSub=state.delivery==='subscribe';
      if(!d.variant){ var o0=btn.innerHTML; btn.textContent='Added ✓'; setTimeout(function(){ btn.innerHTML=o0; render(); },1400); return; }
      var item={ id:d.variant, quantity:1 }; if(isSub && d.plan){ item.selling_plan=d.plan; }
      var orig=btn.innerHTML; btn.disabled=true; btn.dataset.busy='1'; btn.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})})
        .then(function(r){ if(!r.ok){ return r.json().then(function(e){ throw e; }); } return r.json(); })
        .then(function(){ btn.textContent='Added ✓'; openCart(root); setTimeout(function(){ btn.disabled=false; btn.removeAttribute('data-busy'); btn.innerHTML=orig; render(); },1300); })
        .catch(function(err){ btn.disabled=false; btn.removeAttribute('data-busy'); btn.textContent=(err&&err.description)?err.description:(btn.dataset.cartError||'Could not add to cart.'); setTimeout(function(){ btn.innerHTML=orig; render(); },2600); });
    }
    if(atcMain) atcMain.addEventListener('click', function(){ if(atcMain.dataset.busy!=='1') addToCart(atcMain); });
    stickyBtns.forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); if(b.dataset.busy!=='1') addToCart(b); }); });

    render();
  }

  function boot(){ document.querySelectorAll('.ee-buy2').forEach(initBuy2); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
